import React from 'react';
import {classes, style} from './doppe-viewer-map-modal-content.st.css';
import {buildLocationNavigateToUrl, buildLocationOpenWithUrl, LocationCoordinates} from "@wix/devzai-utils-common";
import {flexColumn, GoogleMapView} from "@wix/devzai-utils-react";
import {
    DoppeActionTypeWidgetInnerButton
} from "../../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button";

export const DoppeViewerMapModalContent = React.memo(function DoppeViewerMapModalContent (props: DoppeViewerMapModalContent.Props) {
    const {
        className,
        locationCoordinates,
        languageCode,
        zoom,
        navigateToText,
        openWithText,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, flexColumn(), className)}
        >
            <GoogleMapView
                displayMode={'InteractiveReadOnly'}
                locationCoordinates={locationCoordinates}
                zoom={zoom}
                languageCode={languageCode}
            />
            <div className={style(classes.mapExpandedButtonSection, flexColumn())}>
                <DoppeActionTypeWidgetInnerButton
                    className={classes.mapExpandedButton}
                    tagName={'a'}
                    href={buildLocationNavigateToUrl(locationCoordinates.latitude, locationCoordinates.longitude)}
                    rel={'noreferrer'}
                    target={'_blank'}
                    inPopup={true}
                >
                    {navigateToText}
                </DoppeActionTypeWidgetInnerButton>
                <DoppeActionTypeWidgetInnerButton
                    className={classes.mapExpandedButton}
                    tagName={'a'}
                    href={buildLocationOpenWithUrl(locationCoordinates.latitude, locationCoordinates.longitude)}
                    rel={'noreferrer'}
                    target={'_blank'}
                    inPopup={true}
                >
                    {openWithText}
                </DoppeActionTypeWidgetInnerButton>
            </div>
        </div>
    );
});

export namespace DoppeViewerMapModalContent {
    export interface Props extends React.HTMLAttributes<any> {
        locationCoordinates: LocationCoordinates;
        languageCode: string;
        zoom: number;
        navigateToText: string;
        openWithText: string;
    }
}
